export default "__VITE_ASSET__0GxUD_nF__"